import React from 'react';
import Typography from "@material-ui/core/Typography";

export default function EligibilitySubtitle(props) {
    const { text } = props;
    
    return (
        <Typography variant="h6" tabIndex="0">{ text }</Typography>
    );
}
